export class ResetProjectTablesList {
  public static readonly type = '[Project/Tables/List] ResetProjectTablesList';
}
